import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { UserV2 } from '@vi-iot/client';

import { AppState } from '../app.state';

import { CompanyDetails } from './gateway-invitations.model';
import { GatewayInvitationsState } from './gateway-invitations.state';

export namespace GatewayInvitationsSelectors {
  export const invitations = (state: AppState): GatewayInvitationsState => state.gatewayInvitations;

  export function getState(): MemoizedSelector<
    AppState,
    GatewayInvitationsState,
    DefaultProjectorFn<GatewayInvitationsState>
  > {
    return createSelector(invitations, (state: GatewayInvitationsState) => state);
  }

  export function selectInviteeDetails(
    accountId: string
  ): MemoizedSelector<AppState, UserV2, DefaultProjectorFn<UserV2>> {
    return createSelector(
      invitations,
      (state: GatewayInvitationsState) => state.inviteeDetails[accountId]
    );
  }

  export function selectInviterDetails(
    accountId: string
  ): MemoizedSelector<AppState, UserV2, DefaultProjectorFn<UserV2>> {
    return createSelector(
      invitations,
      (state: GatewayInvitationsState) => state.inviterDetails[accountId]
    );
  }

  export function selectInviteeCompanyDetails(
    companyId: string
  ): MemoizedSelector<AppState, CompanyDetails, DefaultProjectorFn<CompanyDetails>> {
    return createSelector(
      invitations,
      (state: GatewayInvitationsState) => state.inviteeCompanyDetails[companyId]
    );
  }

  export function selectInviterCompanyDetails(
    companyId: string
  ): MemoizedSelector<AppState, CompanyDetails, DefaultProjectorFn<CompanyDetails>> {
    return createSelector(
      invitations,
      (state: GatewayInvitationsState) => state.inviterCompanyDetails[companyId]
    );
  }
}
